module.exports = __webpack_public_path__ + "static/media/icon_unionPay.fb27615a.png";